import { AppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/AppConfig';
import { getAppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/FetchConfig';
import { handleApiError } from '@porterin/component-library/src/ts-utils/analytics/sentry/SentryHelpers';
import { getLocaleHeaders } from '@porterin/component-library/src/utils/LocaleHelper';
import { getCookie } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';
import axios from 'axios';

import {
  getClickIds,
  getUtmParams,
  parseUtmParams,
} from '../../components/FareEstimateUtmParamsHelper';
import { PartloadLeadCaptureRequest } from '../api-models/PartloadLeadCaptureApiModel';
import { FareEstimateForm } from '../entities/FareEstimateForm';

const Config: AppConfig = getAppConfig();

const CAPTURE_URL = `${Config.wag_url}/partload/booking/leads/capture`;

export function buildPartloadLeadPayload(
  form: FareEstimateForm,
): PartloadLeadCaptureRequest {
  const utmObject = parseUtmParams(getUtmParams());
  const { fbclid, gclid } = getClickIds();

  return {
    from_address_landmark: form.pickupAddress.landmark,
    to_address_landmark: form.dropAddress.landmark,
    from_address_lat: form.pickupAddress.location.lat,
    from_address_long: form.pickupAddress.location.lng,
    to_address_lat: form.dropAddress.location.lat,
    to_address_long: form.dropAddress.location.lng,
    customer_name: form.name,
    customer_mobile: form.mobile,
    frequency: form.requirement,
    source_url: window.location.href,
    utm_source: utmObject['utm_source'],
    utm_medium: utmObject['utm_medium'],
    utm_campaign: utmObject['utm_campaign'],
    utm_term: utmObject['utm_term'],
    utm_content: utmObject['utm_content'],
    fbclid,
    gclid,
  };
}

export async function capturePartloadLead(
  form: FareEstimateForm,
): Promise<boolean> {
  try {
    const payload = buildPartloadLeadPayload(form);
    await axios.post(CAPTURE_URL, payload, {
      headers: {
        ...getLocaleHeaders(),
        'Content-Type': 'application/json',
        'visitor-id': getCookie('visitor_id') ?? null,
      },
    });
    return true;
  } catch (error: unknown) {
    handleApiError(error, 'capturePartloadLead');
    return false;
  }
}
